import { MenuOpenIcon, SettingsIcon } from '@assets/icons';
import { AvatarImg, Logo } from '@assets/images';
import { useAppDispatch, useAppSelector } from '@hooks';
import {
  AppBar,
  Avatar,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from '@mui/material';
import { logout, showConfirm, toggleMenu } from '@redux/actions';
import { Routes } from '@utils/constants';
import { FC, MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './Header.scss';

const Header: FC = () => {
  const dispath = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { openMenu } = useAppSelector((state) => state.app);
  const { user } = useAppSelector((state) => state.auth);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpenSettings = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseSettings = () => {
    setAnchorEl(null);
  };
  const updateAccount = () => {
    setAnchorEl(null);
    navigate(Routes.ACCOUNT_INFO);
  };

  const goToAccount = () => {
    setAnchorEl(null);
    navigate(Routes.ACCOUNT);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    dispath(
      showConfirm({
        title: 'common.logout',
        content: 'common.logout_confirm',
        onConfirm: () => dispath(logout()),
      }),
    );
  };

  return (
    <AppBar position="sticky" className="Header">
      <Toolbar className="HeaderToolbar">
        <div className="HeaderToolbar__logo">
          {openMenu && (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu-close"
              onClick={() => dispath(toggleMenu())}
            >
              <MenuOpenIcon />
            </IconButton>
          )}
          <img src={Logo} onClick={() => navigate(Routes.APPLICATION_LIST)} />
        </div>
        <div className="HeaderToolbar__settings">
          <Avatar alt={user?.username} src={AvatarImg} />
          <Typography variant="h4">Hi, {user?.username}</Typography>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleOpenSettings}
            color="inherit"
          >
            <SettingsIcon />
          </IconButton>
          <Menu
            id="HeaderMenu"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleCloseSettings}
          >
            <MenuItem onClick={updateAccount}>
              {t('common.account_info')}
            </MenuItem>
            <Divider variant="middle" />
            <MenuItem onClick={goToAccount}>
              {t('common.change_password')}
            </MenuItem>
            <Divider variant="middle" />
            <MenuItem onClick={handleLogout}>{t('common.logout')}</MenuItem>
          </Menu>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
